import { render } from "./Professions.vue?vue&type=template&id=5255036a"
import script from "./Professions.vue?vue&type=script&lang=js"
export * from "./Professions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__